/**
 * Permission constants for settings sections.
 *
 * Extracted from settings-nav-config to avoid circular imports: section
 * components that need these constants are themselves imported by
 * settings-nav-config, so importing settings-nav-config from a section
 * creates a cycle that causes slow/hanging dynamic imports in tests.
 */

export const BILLING_ADMIN_PERMISSION = 'ahoy_other_admin';
export const CRM_ADMIN_PERMISSION = 'ahoy_schema_admin';
export const TEAMS_ADMIN_PERMISSION = 'ahoy_permissions_admin';
// Must equal the backend ActionRoutingSettingsView.ADMIN_GROUP ('ahoy_other_admin').
export const ACTION_ROUTING_ADMIN_PERMISSION = 'ahoy_other_admin';
